import React from "react";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import AppCustomersViewContent from "../Components/AppCustomers";
import RightModal from "../Components/Modals/RightModal/RightModal";

const AppCustomersView = () => {
  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <AppCustomersViewContent />
        <RightModal width={55} />
      </div>
    </ViewScroller>
  );
};

export default AppCustomersView;
